module.exports = __webpack_public_path__ + "static/media/julia.5a1447e9.svg";